import { merge } from 'lodash'

export function withFixedWidthElseAuto(
  bs,
  popoverProps,
  defaultWidth = { minWidth: null, maxWidth: null },
) {
  const { width } = bs
  if (width) {
    return merge({
      statelessBs: {
        minWidth: width,
        maxWidth: width,
      },
    }, popoverProps)
  }
  return merge({
    statelessProps: {
      bs: {
        ...defaultWidth,
      },
    },
  }, popoverProps)
}
